// removed by extract-text-webpack-plugin
module.exports = {"root":"_1iuIZvT2kdr7yl7UCPDmHD","inner":"_1pn8aLqpgJbwgL_5H-R0UC","extra-content":"_22P_xIDOafP9GDPWQp2cJB","size-default":"_2-ETPyHBlp0UfAwW0rYLBJ","size-small":"tg6ePfTuP5BlJ7jlgEgYz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/seperator.scss
// module id = 1416
// module chunks = 0